<template>
  <div class="c-mypagePasswordEdit">
    <section v-if="state == 'edit'">
      <PageTitle
        titleText="パスワード変更"
        asideText="新しいパスワードを入力してください。"
      />
      <section class="mainContent-form">
        <dl class="formTable">
          <dt class="formTable_ttl">
            <span class="icoForm-requir">必須</span>
            <label for="">パスワード</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">
                <label id=""
                  ><input
                    type="text"
                    id=""
                    class="u-input--w100p u-ime-en"
                    maxlength="128"
                    name=""
                    v-model.trim="$v.password.$model"
                    placeholder="8〜20文字 半角英数"
                /></label>
              </div>
              <div class="error" v-if="!$v.password.required">必須です。</div>
              <div class="error" v-if="!$v.password.passwordValidator">
                パスワードは8〜20文字 半角英数
              </div>
            </div>
          </dd>
        </dl>
      </section>
      <div class="c-mypagePasswordEdit__buttonWrap">
        <a href="javascript:void(0);" @click="onConfirm">
          <Button text="変更" width="23rem"></Button>
        </a>
      </div>
    </section>

    <section v-if="state == 'confirm'">
      <PageTitle
        titleText="パスワード変更確認"
        asideText="パスワードを変更します。よろしければ「変更」ボタンをクリックしてください。"
      />
      <section class="mainContent-form">
        <dl class="formTable">
          <dt class="formTable_ttl">
            <label for="">パスワード</label>
          </dt>
          <dd class="formTable_data">
            <div class="formTableBox">
              <div class="formTableBox_itemBox">{{ password }}</div>
            </div>
          </dd>
        </dl>
      </section>
      <div>
        <div class="c-mypagePasswordEdit__buttonWrap">
          <a href="javascript:void(0);" @click="onUpdate">
            <Button text="変更" width="23rem"></Button>
          </a>
        </div>
        <div class="c-mypagePasswordEdit__buttonWrap">
          <a href="javascript:void(0);" @click="state = 'edit'">
            <Button text="戻る" width="23rem"></Button>
          </a>
        </div>
      </div>
    </section>

    <section v-if="state == 'complete'">
      <PageTitle
        titleText="パスワード変更完了"
        asideText="パスワード変更が完了しました。"
      />
      <div class="c-mypagePasswordEdit__buttonWrap">
        <router-link
          :to="{
            name: 'top',
            params: { mc_code: mcCode },
          }"
        >
          <Button text="トップページへ" width="23rem"></Button>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { required, helpers } from "vuelidate/lib/validators";
import UserService from "../../../../services/user.service";
import PageTitle from "@/components/PageTitle.vue";
const passwordValidator = helpers.regex("alpha", /^[0-9a-zA-Z\d]{8,20}$/);
import Button from "@/components/Button.vue";

export default {
  name: "password-edit",
  components: {
    PageTitle,
    Button,
  },
  data() {
    return {
      password: "",
      state: "edit",
    };
  },
  validations: {
    password: {
      required,
      passwordValidator,
    },
  },
  methods: {
    onConfirm() {
      console.log("onConfirm");
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("ERROR");
      } else {
        this.state = "confirm";
      }
    },
    async onUpdate() {
      console.log("onUpdate");
      try {
        const result = await UserService.changePassword(this.password);
        console.log(result);
        this.state = "complete";
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
